<script setup>
// §8.5 Toggle — a NATIVE <input type="checkbox" role="switch">, styled entirely
// with CSS. No JS: the checkbox carries state, focus and keyboard; the track and
// thumb are drawn on the element itself and its ::before. "On" uses the
// interactive colour (D3 reserves the accent for orientation only).
defineProps({
  label: { type: String, default: null },
  // For a switch whose label sits elsewhere on the row (a settings list), so the
  // control still has a name for anyone not looking at the screen.
  ariaLabel: { type: String, default: null },
})
const model = defineModel({ default: false })
</script>

<template>
  <label class="l-toggle">
    <input type="checkbox" role="switch" v-model="model" class="switch" :aria-label="label ? null : ariaLabel" />
    <span v-if="label" class="lbl">{{ label }}</span>
  </label>
</template>

<style scoped>
.l-toggle {
  display: inline-flex;
  align-items: center;
  gap: var(--sp-3);
  cursor: pointer;
  min-height: var(--target-min);
}
.switch {
  appearance: none;
  -webkit-appearance: none;
  position: relative;
  width: 38px;
  height: 22px;
  border-radius: var(--r-pill);
  background: var(--lotus-neutral-400);
  cursor: pointer;
  flex: none;
  transition: background var(--t-fast) var(--ease);
}
.switch::before {
  content: '';
  position: absolute;
  top: 2px;
  left: 2px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: var(--on-emphasis);
  box-shadow: var(--shadow-thumb);
  transition: transform var(--t-fast) var(--ease);
}
.switch:checked {
  background: var(--interactive);
}
.switch:checked::before {
  transform: translateX(16px);
}
.lbl {
  font-size: var(--text-base);
  color: var(--text);
}
</style>
